import React from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import Dashboard from "../components/onepage_dashboard/Dashboard";

const DashboardProduksi = () => {
    // Only apply overflow="hidden" for laptop and larger screens
    const overflowValue = useBreakpointValue({ 
        base: "auto",    // mobile
        md: "auto",      // tablet
        lg: "auto"     // laptop and larger
    });

    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1} overflow={overflowValue}>
                <Dashboard />
            </Box>
        </Box>
    );
};

export default DashboardProduksi;